export class Aeronave {
  id: string;
  matricula: string;
  modelo: string;
  aerocombustible: string;
  nuevo: boolean;
  tipoVehiculo: number;
}
